var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "user-page" } },
    [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "title" } }, [
        _c("div", { staticClass: "col-1" }, [
          _c(
            "svg",
            {
              staticClass: "bd-placeholder-img mr-2 rounded",
              attrs: {
                id: "header",
                width: "28",
                height: "28",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false",
                role: "img",
                "aria-label": "Placeholder: 32x32",
              },
            },
            [
              _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
              }),
            ]
          ),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "col-3" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-info btn_right",
              attrs: { id: "backBtn", type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("キャンセルする")]
          ),
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-danger btn_right",
              attrs: { id: "destroyBtn", type: "button" },
              on: { click: _vm.destroy },
            },
            [_vm._v("削除する")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-8" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.modify.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.folder.folderName,
                          expression: "folder.folderName",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "30",
                        autocomplete: "off",
                        placeholder: "フォルダ名",
                        required: "",
                      },
                      domProps: { value: _vm.folder.folderName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.folder,
                            "folderName",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "col-9" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.folder.type,
                            expression: "folder.type",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.folder,
                              "type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("所属（組織）"),
                        ]),
                        _c("option", { attrs: { value: "2" } }, [
                          _vm._v("ユーザーグループ"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm.isOrganization
                ? _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "row" }, [
                      _vm._m(3),
                      _c("div", { staticClass: "col-9" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.folder.organizationId,
                                expression: "folder.organizationId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.folder,
                                  "organizationId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.organizationOptions, function (option) {
                            return _c(
                              "option",
                              {
                                key: option.id,
                                domProps: { value: option.id },
                              },
                              [_vm._v(" " + _vm._s(option.displayName) + " ")]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              !_vm.isOrganization
                ? _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "row" }, [
                      _vm._m(4),
                      _c("div", { staticClass: "col-9" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.folder.groupId,
                                expression: "folder.groupId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.folder,
                                  "groupId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.groupOptions, function (option) {
                            return _c(
                              "option",
                              {
                                key: option.id,
                                domProps: { value: option.id },
                              },
                              [_vm._v(" " + _vm._s(option.groupName) + " ")]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn btn-block",
                  attrs: { id: "modify_button", type: "submit" },
                },
                [_vm._v("更新する")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("フォルダ変更")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("フォルダ名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("共有先")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("所属（組織）")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("ユーザーグループ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }